import React from "react";

// Pictogrammes des deux natures de publication (Passion/Power), partagés par toutes les pages qui
// en ont besoin en dehors du système GLYPH_PATHS d'Explore.tsx (WelcomePopup, Profile, Search…) —
// jusqu'ici ces pages imprimaient l'emoji ⚡ en dur, alors que la carte utilise déjà un vrai SVG
// tracé. Même convention que les icônes de catégorie FAST : viewBox 24×24, stroke, jamais d'emoji
// comme élément graphique principal. Les chaînes *_PATH sont aussi consommées telles quelles par
// GLYPH_PATHS (Explore.tsx) pour que la carte et le reste de l'app restent visuellement identiques.
export const FLAME_PATH = `<path d="M12 2.6c2.9 3.5 5.4 5.9 5.4 9.5a5.4 5.4 0 0 1-10.8 0c0-1.9 1-3.4 2.2-4.8.5.9 1.1 1.5 1.9 1.9-.1-2.2.3-4.3 1.3-6.6z"/>`;

// Poing levé — remplace le bras fléchi (biceps), lui-même une tentative de remplacement de
// l'ancienne charge électrique des Powers. Le bras n'a jamais trouvé de tracé qui reste lisible
// à la fois à grande taille et à la taille d'usage réelle (11-18px) sans se refermer en hameçon ;
// le poing (articulations + poignet) garde des repères nets (bosses, encoche du poignet) qui
// résistent bien mieux à la miniaturisation. Même esprit que la flamme des Passions : un tracé
// fin (pas un aplat), un seul geste continu. Vérifié visuellement à plusieurs échelles avant
// adoption (voir la leçon du "Q"/loupe et du bras plus tôt dans cette session).
export const FIST_PATH = `<path d="M9 22v-6.5c-2.2-.7-3.5-2.6-3.5-5V9c0-.6.4-1 1-1s1 .4 1 1v1M8.5 8V5.3a1.2 1.2 0 0 1 2.4 0V8M11.5 8V4.8a1.2 1.2 0 0 1 2.4 0V8M14.5 8.2V6a1.2 1.2 0 0 1 2.4 0v2.7c1.6.7 2.6 2.3 2.6 4.2v2.6c0 3.6-2.9 6.5-6.5 6.5h-1c-1.8 0-3.1-.6-4.2-1.8"/>`;

type IconProps = { size?: number; color?: string };

export const PassionIcon = ({ size = 20, color = "#0a0a0a" }: IconProps) => (
  <svg
    width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={1.9}
    strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}
    dangerouslySetInnerHTML={{ __html: FLAME_PATH }}
  />
);

export const PowerIcon = ({ size = 20, color = "#0a0a0a" }: IconProps) => (
  <svg
    width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={1.9}
    strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}
    dangerouslySetInnerHTML={{ __html: FIST_PATH }}
  />
);
